import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { AbandonCheckout } from 'src/constrains/AdvancedFilters/Components';
import { EAbandonedCheckout } from 'src/constrains/AdvancedFilters/Components/AbandonCheckout';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
const _AbandonCheckout = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    rootName,
    form,
    noStyle,
    radioName,

    defaultState,
    ...rest
  } = props;
  const handleOnReset = () => {
    form.setFieldsValue(defaultState);
  };
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(rootName);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const type = getFieldValue(radioName);
        const handleOnClose = () => {
          //   form
          //     .validateFields([radioName, selectName])
          //     .then(() => {
          //       //console.log('没错');
          //     })
          //     .catch((r) => {
          //       handleOnReset();
          //     });
        };
        const hasData = !!type;
        const textGenerate = () => {
          if (hasData)
            return {
              [EAbandonedCheckout.HAVE]: getI18n(
                'customerList.abandonCheckout.eAbandonedCheckout.HAVE',
              ),
              [EAbandonedCheckout.NOT_HAVE]: getI18n(
                'customerList.abandonCheckout.eAbandonedCheckout.NOT_HAVE',
              ),
            }[type];
        };

        return (
          <Co
            header={
              <div>
                {getI18n('customerList.abandonCheckout.abandonedcheckout')}
              </div>
            }
            displayText={textGenerate()}
            hasData={hasData}
            onClose={handleOnClose}
            onClear={handleOnReset}>
            <AbandonCheckout
              noStyle={noStyle}
              radioName={radioName}
              {...rest}
            />
          </Co>
        );
      }}
    </Item>
  );
};
export default _AbandonCheckout;
